module.exports = __webpack_public_path__ + "static/media/avatar_cat.8bd4005e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/avatar_cat.png
// module id = 370
// module chunks = 0